import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { 
  ShoppingCart,
  Star,
  Filter,
  Send,
  Share2,
  Heart,
  ChevronRight
} from 'lucide-react';
import Navigation from '../components/Navigation';

const MerchPage = () => {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    console.log('Newsletter signup:', email);
  };

  const featuredProducts = [
    {
      image: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=600&h=600&fit=crop',
      name: 'Purpose Hoodie',
      caption: 'Faith in Action',
      price: '$65',
      badge: 'Limited Edition'
    },
    {
      image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=600&h=600&fit=crop',
      name: 'Known Tee',
      caption: 'Classic Fit',
      price: '$35',
      badge: null
    },
    {
      image: 'https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=600&h=600&fit=crop',
      name: 'Faith Cap',
      caption: 'Unstructured Dad Hat',
      price: '$28',
      badge: 'New'
    },
    {
      image: 'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=600&h=600&fit=crop',
      name: 'Purpose Tote',
      caption: 'Canvas Bag',
      price: '$32',
      badge: null
    }
  ];

  const categories = [
    {
      image: 'https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=800&h=600&fit=crop',
      title: 'Apparel',
      description: 'Hoodies, Tees, & More'
    },
    {
      image: 'https://images.unsplash.com/photo-1622445275463-afa2ab738c34?w=800&h=600&fit=crop',
      title: 'Accessories',
      description: 'Hats, Bags, & Pins'
    },
    {
      image: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=800&h=600&fit=crop',
      title: 'Journals & Books',
      description: 'Faith Resources'
    },
    {
      image: 'https://images.unsplash.com/photo-1550009158-9ebf69173e03?w=800&h=600&fit=crop',
      title: 'Digital Products',
      description: 'Downloads & Media'
    }
  ];

  const products = [
    {
      image: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=400&h=400&fit=crop',
      title: 'Purpose Hoodie - Navy',
      price: '$65'
    },
    {
      image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=400&fit=crop',
      title: 'Known Tee - White',
      price: '$35'
    },
    {
      image: 'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?w=400&h=400&fit=crop',
      title: 'Faith Crewneck - Gold',
      price: '$55'
    },
    {
      image: 'https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=400&h=400&fit=crop',
      title: 'Faith Cap - Navy',
      price: '$28'
    },
    {
      image: 'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=400&h=400&fit=crop',
      title: 'Purpose Tote - Natural',
      price: '$32'
    },
    {
      image: 'https://images.unsplash.com/photo-1608613304810-2d4dd52511a2?w=400&h=400&fit=crop',
      title: 'Culture Long Sleeve',
      price: '$42'
    }
  ];

  const socialPhotos = [
    'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=400&h=400&fit=crop',
    'https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=400&h=400&fit=crop',
    'https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=400&h=400&fit=crop',
    'https://images.unsplash.com/photo-1556740749-887f6717d7e4?w=400&h=400&fit=crop',
    'https://images.unsplash.com/photo-1559027615-cd4628902d4a?w=400&h=400&fit=crop',
    'https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?w=400&h=400&fit=crop'
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <div className="relative h-[600px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ 
            backgroundImage: `url('https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=1920&h=1080&fit=crop')`
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B1B3B]/90 via-[#0B1B3B]/80 to-[#0B1B3B]/70" />
        
        <div className="relative z-10 text-center text-white px-4 max-w-5xl">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Official KNOWN CON <span className="text-[#CFA64B]">Merch</span>
          </h1>
          <p className="text-xl md:text-2xl mb-10 text-gray-200">
            Wear the movement. Live the message.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button className="bg-[#CFA64B] hover:bg-[#BD954A] text-[#0B1B3B] font-bold px-10 py-6 text-lg">
              <ShoppingCart className="w-5 h-5 mr-2" />
              Shop Now
            </Button>
            <Button variant="outline" className="bg-white/10 hover:bg-white/20 text-white border-white px-10 py-6 text-lg">
              View Collections
            </Button>
          </div>
        </div>
      </div>

      {/* Section 1: Featured Collection */}
      <div className="py-20" style={{ backgroundColor: '#FFF9E9' }}>
        <div className="max-w-[1440px] mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#0B1B3B] mb-4">This Year's Drop</h2>
            <p className="text-xl text-gray-600">Limited edition pieces from the 2025 collection</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {featuredProducts.map((product, idx) => (
              <Card 
                key={idx}
                className="border-none shadow-lg hover:shadow-2xl transition-all duration-300 group overflow-hidden"
              >
                <div className="relative">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  {product.badge && (
                    <div className="absolute top-4 right-4 bg-[#CFA64B] text-[#0B1B3B] px-3 py-1 rounded-full text-xs font-bold">
                      {product.badge}
                    </div>
                  )}
                </div>
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-[#0B1B3B] mb-2">{product.name}</h3>
                  <p className="text-sm text-gray-600 mb-3">{product.caption}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-2xl font-bold text-[#0B1B3B]">{product.price}</span>
                    <Button className="bg-[#0B1B3B] hover:bg-[#1a2f5a] text-white">
                      View Item
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>

      {/* Section 2: Collection Grid */}
      <div className="py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#0B1B3B] mb-4">Shop by Category</h2>
            <p className="text-xl text-gray-600">Find exactly what you're looking for</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {categories.map((category, idx) => (
              <div
                key={idx}
                className="relative h-80 rounded-2xl overflow-hidden group cursor-pointer"
              >
                <img 
                  src={category.image} 
                  alt={category.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1B3B]/90 via-[#0B1B3B]/40 to-transparent group-hover:from-[#CFA64B]/90 transition-all duration-300" />
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <h3 className="text-2xl font-bold mb-2">{category.title}</h3>
                  <p className="text-sm text-gray-200">{category.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Section 3: Product Grid */}
      <div className="py-20 bg-gray-50">
        <div className="max-w-[1440px] mx-auto px-6">
          {/* Filters */}
          <div className="flex flex-wrap items-center justify-between mb-12 gap-4">
            <h2 className="text-3xl font-bold text-[#0B1B3B]">All Products</h2>
            <div className="flex gap-3">
              <Button variant="outline" className="border-gray-300">
                <Filter className="w-4 h-4 mr-2" />
                Category
              </Button>
              <Button variant="outline" className="border-gray-300">
                Price Range
              </Button>
              <Button variant="outline" className="border-gray-300">
                New Arrivals
              </Button>
            </div>
          </div>

          <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-8">
            {products.map((product, idx) => (
              <Card 
                key={idx}
                className="border-none shadow-md hover:shadow-xl transition-all duration-300 group"
              >
                <div className="relative overflow-hidden">
                  <img 
                    src={product.image} 
                    alt={product.title}
                    className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <button className="absolute top-4 right-4 w-10 h-10 bg-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <Heart className="w-5 h-5 text-gray-600" />
                  </button>
                </div>
                <CardContent className="p-4">
                  <h3 className="text-lg font-bold text-[#0B1B3B] mb-2">{product.title}</h3>
                  <div className="flex items-center justify-between">
                    <span className="text-xl font-bold text-[#0B1B3B]">{product.price}</span>
                    <Button size="sm" className="bg-[#CFA64B] hover:bg-[#BD954A] text-[#0B1B3B] font-bold">
                      Add to Cart
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>

      {/* Section 4: Lifestyle / Story Strip */}
      <div className="relative py-32 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url('https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1920&h=800&fit=crop')` }}
        />
        <div className="absolute inset-0 bg-[#0B1B3B]/80" />
        
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-white">
          <h2 className="text-4xl md:text-6xl font-bold mb-6">
            Every purchase supports community initiatives and scholarships.
          </h2>
          <Button variant="outline" className="bg-transparent border-white text-white hover:bg-white/10 px-8 py-4 text-lg">
            Learn More About Impact
            <ChevronRight className="w-5 h-5 ml-2" />
          </Button>
        </div>
      </div>

      {/* Section 5: Limited Edition Call-Out */}
      <div className="py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative h-[500px] rounded-3xl overflow-hidden border-4 border-[#CFA64B]">
              <img 
                src="https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=800&h=800&fit=crop" 
                alt="Limited Edition"
                className="w-full h-full object-cover"
              />
              <div className="absolute top-6 left-6 bg-[#CFA64B] text-[#0B1B3B] px-4 py-2 rounded-full font-bold">
                Limited Run
              </div>
            </div>
            <div>
              <div className="inline-block px-4 py-2 bg-[#CFA64B]/10 text-[#CFA64B] rounded-full text-sm font-bold mb-4">
                EXCLUSIVE DROP
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0B1B3B] mb-6">
                Limited Edition:<br/>The Faith & Culture Capsule
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                A curated collection celebrating the intersection of faith and culture. Each piece 
                is numbered and features exclusive designs available only during KNOWN CON 2025.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                Only 500 pieces produced. Once they're gone, they're gone forever.
              </p>
              <Button className="bg-[#CFA64B] hover:bg-[#BD954A] text-[#0B1B3B] font-bold px-10 py-6 text-lg">
                Get Yours Now
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Section 6: Newsletter / Discount CTA */}
      <div className="py-20 bg-gradient-to-r from-[#CFA64B] to-[#d97706]">
        <div className="max-w-[900px] mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B1B3B] mb-4">
            Be first to know about new drops and discounts.
          </h2>
          <p className="text-xl text-[#0B1B3B]/80 mb-8">No spam, just inspiration.</p>
          
          <form onSubmit={handleNewsletterSubmit} className="flex flex-col sm:flex-row gap-4 max-w-2xl mx-auto">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="flex-1 px-6 py-4 rounded-full text-lg focus:outline-none focus:ring-2 focus:ring-[#0B1B3B]"
            />
            <Button type="submit" className="bg-[#0B1B3B] hover:bg-[#1a2f5a] text-white font-bold px-10 py-4 rounded-full text-lg">
              <Send className="w-5 h-5 mr-2" />
              Subscribe
            </Button>
          </form>
        </div>
      </div>

      {/* Section 7: Social Proof */}
      <div className="py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#0B1B3B] mb-4">Spotted at KNOWN CON</h2>
            <p className="text-xl text-gray-600">#KnownCon #FaithCulturePurpose</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {socialPhotos.map((photo, idx) => (
              <div 
                key={idx}
                className="relative aspect-square rounded-lg overflow-hidden group cursor-pointer"
              >
                <img 
                  src={photo} 
                  alt={`Social ${idx + 1}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-[#CFA64B]/0 group-hover:bg-[#CFA64B]/20 transition-all duration-300 flex items-center justify-center">
                  <Heart className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Button variant="outline" className="border-[#CFA64B] text-[#CFA64B] hover:bg-[#CFA64B] hover:text-white px-8 py-4 text-lg">
              <Share2 className="w-5 h-5 mr-2" />
              Share Your Look
            </Button>
          </div>
        </div>
      </div>

      {/* Section 8: Final CTA */}
      <div className="relative py-24 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B1B3B] via-[#1a2f5a] to-[#CFA64B]" />
        
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-white">
          <h2 className="text-4xl md:text-6xl font-bold mb-10">
            Shop with purpose. Every piece tells a story.
          </h2>
          <Button className="bg-white text-[#0B1B3B] hover:bg-gray-100 font-bold px-10 py-6 text-lg">
            <ShoppingCart className="w-5 h-5 mr-2" />
            Shop Now
          </Button>
        </div>
      </div>

      {/* Quick Links */}
      <div className="py-6 bg-gray-50 border-t border-gray-200">
        <div className="max-w-[1440px] mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <a href="/attendee-guide" className="text-[#0B1B3B] hover:text-[#CFA64B] font-medium transition-colors">
              Attendee Guide
            </a>
            <span className="text-gray-400">|</span>
            <a href="/faqs" className="text-[#0B1B3B] hover:text-[#CFA64B] font-medium transition-colors">
              FAQs
            </a>
            <span className="text-gray-400">|</span>
            <a href="#contact" className="text-[#0B1B3B] hover:text-[#CFA64B] font-medium transition-colors">
              Contact Support
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#0f172a] text-white py-12">
        <div className="max-w-[1440px] mx-auto px-6 text-center">
          <p className="text-gray-400 text-sm">© 2025 KNOWN CON. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default MerchPage;
